/** エラーコードから、画面に表示するメッセージを決める(廃止した共通サイト `client-common` のエラー画面から移したもの) */
export const getErrorMessage = (errorCode: string = ''): string => {
  // 許可されていない IP アドレス
  if (errorCode === 'UNAUTHORIZED_IP_ADDRESS') {
    return 'アクセス元のネットワークからは利用できません。';
  }
  if (errorCode.includes('404')) {
    return '[404] お探しのページは見つかりませんでした';
  }
  if (errorCode.includes('401')) {
    return '[401] 認証エラーが発生しました。再度サインインしてください。';
  }
  return '[500] エラーが発生しました';
};
